module.exports = __webpack_public_path__ + "static/media/grid.9713ee38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/grid.svg
// module id = 1398
// module chunks = 0